/* eslint-disable @typescript-eslint/no-unused-vars */
import React from 'react';
import Chart from 'react-apexcharts';

interface GraficoAreaProps {
  height?: number;
  series: {
    name: string;
    data: number[];
  }[];
  options?: {
    title?: {
      text?: string;
    };
    colors?: string[];
    dataLabels?: {
      enabled?: boolean;
    };
    theme?: {
      mode?: 'dark' | 'light' | undefined;
    };
    xaxis?: { 
      categories?: string[];
    } 
  };
}

const GraficoArea: React.FC<GraficoAreaProps> = ({ series, options = {}, height }) => {
  return (
    <React.Fragment>
      <Chart
        type='area'
        
        height={height || 250}
        series={series}
        options={{
          title: {
            text: options.title?.text,
          },
          grid: {
            padding: {
              top: 0,
              right: 30,
              bottom: 5,
              left: 30
            }
          },
          colors: options.colors,
          dataLabels: { enabled: options.dataLabels?.enabled },
          theme: {
            mode: options.theme?.mode,
          },
          yaxis: {
            labels: {
              formatter: function (value) {
                return value.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
              }
            },
            show: false
          },
          xaxis: { 
            categories: options.xaxis?.categories
          }
        }}
      />
    </React.Fragment>
  );
};

export default GraficoArea;
